import type { FC, PropsWithChildren } from "react";

export interface IButtonCellBase {}

/**
 * Функция используется для детей ButtonCell (ButtonCellAction / ButtonCellSchevron / ButtonCellSchevronOption) ->
 * Чтобы не дублировать создание дефолтных компонентов
 */
export const createButtonCellComponent = (
    displayName: string,
): FC<PropsWithChildren<IButtonCellBase>> => {
    const Component: FC<PropsWithChildren<IButtonCellBase>> = ({ children }) =>
        children;
    Component.displayName = displayName;
    return Component;
};
